export const countDown = () => {
  const counters = document.querySelectorAll('.count-down');
  const dataSet: any = {};

  counters.forEach((counter, i) => {
    const targetValue = parseFloat(
      counter.textContent.replaceAll(',', '').trim()
    );
    dataSet[i] = targetValue; // save target value
  });

  function animateCounters() {
    requestAnimationFrame(() => stepAnimation(0)); // smooth animation
  }

  // handle animation
  function stepAnimation(step: number) {
    const totalSteps = 30;

    if (step <= totalSteps) {
      counters.forEach((counter, i) => {
        const targetValue = parseFloat(dataSet[i]);
        const isCountdown =
          (Number.isInteger(targetValue) && targetValue < 5) ||
          counter.hasAttribute('countdown');
        let currentValue;

        if (isCountdown) {
          const range = 100 - targetValue;
          currentValue = 100 - (step / totalSteps) * range;
        } else {
          currentValue = (step / totalSteps) * targetValue;
        }

        let displayValue;
        if (Number.isInteger(targetValue)) {
          displayValue = Math.round(currentValue);
        } else {
          displayValue = currentValue.toFixed(2);
        }
        const countFormat = counter.getAttribute('data-format');
        if (countFormat === 'comma') {
          displayValue = displayValue
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        counter.classList.remove('opacity-0');
        counter.textContent = '' + displayValue;
      });

      requestAnimationFrame(() => stepAnimation(step + 1));
    } else {
      counters.forEach((counter, i) => {
        const countFormat = counter.getAttribute('data-format');
        if (countFormat === 'comma') {
          counter.textContent = dataSet[i]
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
          counter.textContent = dataSet[i];
        }
      });
    }
  }

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounters();
          observer.unobserve(entry.target); // only animate once
        }
      });
    },
    {
      threshold: 0.1 // when 10% of the element is visible
    }
  );

  counters.forEach((counter) => {
    observer.observe(counter); // observe element
  });

  return () => {
    counters.forEach((counter) => {
      observer.unobserve(counter); // stop observing element
    });
  };
};
